import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {StatusComponent} from './status/status.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { DpeComponent } from './dpe/dpe.component';
import { GesComponent } from './ges/ges.component';
import {AiAnalysisComponent} from '@module/favorites/popup/ai-analysis/ai-analysis.component';
import {BuyCongratsComponent} from './buy-congrats/buy-congrats.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {StarRatingModule} from 'angular-star-rating';
import {AiResultComponent} from './ai-result/ai-result.component';
import {AdemeInputComponent} from './ademe-input/ademe-input.component';
import {MatCheckboxModule} from '@angular/material/checkbox';

@NgModule({
    declarations: [StatusComponent, DpeComponent, GesComponent, AiAnalysisComponent, BuyCongratsComponent, AiResultComponent, AdemeInputComponent],
    exports: [StatusComponent, GesComponent, DpeComponent, AiAnalysisComponent, BuyCongratsComponent, AiResultComponent, AdemeInputComponent],
    imports: [
        CommonModule,
        RouterModule,
        MatFormFieldModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        StarRatingModule.forChild(),
    ]
})
export class FavoriteModule {
}
